import { ReferralXlsxDto, ReferralService } from 'common/api';
import { serviceRequest } from 'utils/http';

export function downloadXlsAPI(bodyRequest: ReferralXlsxDto) {
  return serviceRequest(() =>
    ReferralService.referralControllerDownloadXlsx(bodyRequest)
  );
}
